module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/video-gray-b5af5fdf120a94e709c226aa7a5739df.svg";